(() => {
  if (window.TOProductMediaBridge) return;
  window.TOProductMediaBridge = true;

  let returnFocus = null;
  let requestSerial = 0;
  let touchStart = null;

  function dialogTriggers(dialog) {
    const root = dialog && dialog.closest('[data-product-root]');
    return root ? Array.from(root.querySelectorAll('[data-media-open]')) : [];
  }

  function updateDialog(dialog, requestedPosition) {
    const triggers = dialogTriggers(dialog);
    const image = dialog && dialog.querySelector('[data-media-dialog-image]');
    if (!dialog || !image || !triggers.length) return;

    const position = ((Number(requestedPosition) % triggers.length) + triggers.length) % triggers.length;
    const trigger = triggers[position];
    const previewImage = trigger.querySelector('img');
    const previewSource = previewImage && previewImage.currentSrc
      || trigger.dataset.mediaPreviewSrc
      || previewImage && previewImage.src;
    const fullSource = trigger.dataset.mediaSrc;
    const requestKey = `${position}-${requestSerial += 1}`;

    dialog.dataset.mediaPosition = String(position);
    dialog.dataset.mediaRequest = requestKey;
    image.src = previewSource || fullSource;
    image.alt = trigger.dataset.mediaAlt || '';
    image.width = Number(trigger.dataset.mediaWidth) || image.width;
    image.height = Number(trigger.dataset.mediaHeight) || image.height;

    const current = dialog.querySelector('[data-dialog-media-current]');
    if (current) current.textContent = String(position + 1).padStart(2, '0');

    if (!previewSource || !fullSource || previewSource === fullSource) return;

    const fullImage = new Image();
    fullImage.alt = image.alt;
    fullImage.width = image.width;
    fullImage.height = image.height;
    fullImage.setAttribute('data-media-dialog-image', '');

    const showFullImage = () => {
      if (dialog.dataset.mediaRequest !== requestKey) return;
      const currentImage = dialog.querySelector('[data-media-dialog-image]');
      if (currentImage) currentImage.replaceWith(fullImage);
    };

    fullImage.src = fullSource;
    if (typeof fullImage.decode === 'function') {
      fullImage.decode().then(showFullImage).catch(() => {
        if (fullImage.complete && fullImage.naturalWidth > 0) showFullImage();
      });
    } else {
      fullImage.onload = showFullImage;
    }
  }

  function openDialog(trigger) {
    const root = trigger.closest('[data-product-root]');
    const dialog = root && root.querySelector('[data-product-media-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    document.querySelectorAll('dialog[open]').forEach((open) => {
      if (open !== dialog) open.close();
    });

    const triggers = dialogTriggers(dialog);
    updateDialog(dialog, Math.max(0, triggers.indexOf(trigger)));
    returnFocus = trigger;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('is-locked');

    window.setTimeout(() => {
      const close = dialog.querySelector('[data-dialog-close]');
      if (close) close.focus();
    }, 20);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-media-open]');
    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openDialog(trigger);
      return;
    }

    const step = event.target.closest('[data-dialog-media-step]');
    if (!step) return;
    const dialog = step.closest('[data-product-media-dialog]');
    if (!dialog || !dialog.open) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    updateDialog(dialog, Number(dialog.dataset.mediaPosition || 0) + Number(step.dataset.dialogMediaStep));
  }, true);

  document.addEventListener('keydown', (event) => {
    const dialog = document.querySelector('[data-product-media-dialog][open]');
    if (!dialog || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    updateDialog(dialog, Number(dialog.dataset.mediaPosition || 0) + (event.key === 'ArrowLeft' ? -1 : 1));
  }, true);

  document.addEventListener('touchstart', (event) => {
    if (!event.target.closest('[data-product-media-dialog][open] .media-dialog__stage')) return;
    const touch = event.touches[0];
    touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
  }, { capture: true, passive: true });

  document.addEventListener('touchend', (event) => {
    const dialog = event.target.closest('[data-product-media-dialog][open]');
    const touch = event.changedTouches[0];
    if (!dialog || !touch || !touchStart) return;
    const deltaX = touch.clientX - touchStart.x;
    const deltaY = touch.clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    event.stopImmediatePropagation();
    updateDialog(dialog, Number(dialog.dataset.mediaPosition || 0) + (deltaX < 0 ? 1 : -1));
  }, { capture: true, passive: true });

  document.addEventListener('close', (event) => {
    if (!event.target.matches('[data-product-media-dialog]')) return;
    if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('is-locked');
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
    returnFocus = null;
  }, true);
})();
